import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

/* loader component for Suspense*/
import PageLoader from './components/Common/PageLoader';

import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
// import BaseHorizontal from './components/Layout/BaseHorizontal';

/* Used to render a lazy component with react-router */
const waitFor = Tag => props => <Tag {...props}/>;

const Login = lazy(() => import('./components/CRM/Login'));
const Inicio = lazy(() => import('./components/CRM/Inicio'));
const UsuariosTrial = lazy(() => import('./components/CRM/UsuariosTrial'));
const Prospectos = lazy(() => import('./components/CRM/Prospectos'));
const Prospecto = lazy(() => import('./components/CRM/Prospecto'));
const Clientes = lazy(() => import('./components/CRM/Clientes'));
const Cliente = lazy(() => import('./components/CRM/Cliente'));
const Consultores = lazy(() => import('./components/CRM/Consultores'));
const Consultor = lazy(() => import('./components/CRM/Consultor'));
const CambiarContrasena = lazy(() => import('./components/CRM/CambiarContrasena'));
const CambiarImagen = lazy(() => import('./components/CRM/CambiarImagen'));
const CentroMensajes = lazy(() => import('./components/CRM/CentroMensajes'));
const Soporte = lazy(() => import('./components/CRM/Soporte'));
const SoporteDocumentos = lazy(() => import('./components/CRM/SoporteDocumentos'));
const SoportePreguntasFrecuentes = lazy(() => import('./components/CRM/SoportePreguntasFrecuentes'));
const SoporteTickets = lazy(() => import('./components/CRM/SoporteTickets'));
const SolicitudesAlta = lazy(() => import('./components/CRM/SolicitudesAlta'));
// List of routes that uses the page layout
// listed here to Switch between layouts
// depending on the current pathname
const listofPages = [
    '/login',
    '/recuperar'
];

const Routes = ({ location }) => {
  const currentKey = location.pathname.split('/')[1] || '/';
  const timeout = { enter: 500, exit: 500 };

  // Animations supported
  //      'rag-fadeIn'
  //      'rag-fadeInRight'
  //      'rag-fadeInLeft'

  const animationName = 'rag-fadeIn';
  var sPathName = (location.pathname).toLowerCase();
  var boolSessionIniciada = false;
  if ( sessionStorage.getItem('iIDConsultor') != null ) {
    boolSessionIniciada = true;
  }
  var sTipo = sessionStorage.getItem('sTipo');

  if(listofPages.indexOf(location.pathname) > -1) {
    return (
      // Page Layout component wrapper
      <BasePage>
        <Suspense fallback={<PageLoader/>}>
          <Switch location={location}>
            <Route path="/login" component={waitFor(Login)}/>

          </Switch>
        </Suspense>
      </BasePage>
    )
  } else if ( !boolSessionIniciada ) {//Si no tiene sesión ingresada, enviar a login
      return (
          <Redirect to="/login" />//Ruta predeterminada
      )
  } else if ( //Verificar permisos
    ( sPathName === "/usuariostrial" &&  sTipo === "Consultor" )  ||
    ( sPathName === "/consultores" &&  sTipo === "Consultor" ) ||
    ( sPathName === "/solicitudes-alta" &&  sTipo === "Consultor" )
  ){
    return (
      <Redirect to="/inicio" />//Redireccionar al inicio si no cuenta con permisos
      )
  } else {


    return (
      // Layout component wrapper
      // Use <BaseHorizontal> to change layout
      <Base>
        <TransitionGroup>
          <CSSTransition key={currentKey} timeout={timeout} classNames={animationName} exit={false}>
            <div>
              <Suspense fallback={<PageLoader/>}>
                <Switch location={location}>
                  <Route path="/login" component={waitFor(Login)}/>
                  <Route path="/inicio" component={waitFor(Inicio)}/>//Dashboard inicial
                  <Route path="/usuariostrial" component={waitFor(UsuariosTrial)}/>//Modulo de prospectos
                  <Route path="/prospectos" component={waitFor(Prospectos)}/>//Modulo de prospectos
                  <Route path="/prospecto" component={waitFor(Prospecto)}/>//Guardar/Editar prospecto
                  <Route path="/clientes" component={waitFor(Clientes)}/>//Modulo de Clientes
                  <Route path="/cliente" component={waitFor(Cliente)}/>//Guardar/Editar cliente
                  <Route path="/consultores" component={waitFor(Consultores)}/>//Modulo de consultores
                  <Route path="/consultor" component={waitFor(Consultor)}/>//Modulo de consultor
                  <Route path="/cambiar-contrasena" component={waitFor(CambiarContrasena)}/>//Cambiar contraseña
                  <Route path="/cambiar-imagen" component={waitFor(CambiarImagen)}/>//Cambiar imagen
                  <Route path="/centro-mensajes" component={waitFor(CentroMensajes)}/>//Modulo de centro de mensajes
                  <Route path="/soporte" component={waitFor(Soporte)}/>//Administrador de Soporte
                  <Route path="/soporte-documentos" component={waitFor(SoporteDocumentos)}/>//Administrador de Soporte
                  <Route path="/soporte-preguntas-frecuentes" component={waitFor(SoportePreguntasFrecuentes)}/>//Administrador de preguntas frecuentes
                  <Route path="/soporte-tickets" component={waitFor(SoporteTickets)}/>//Administrador de tickets
                  <Route path="/solicitudes-alta" component={waitFor(SolicitudesAlta)}/>//Administrador de tickets

                  <Redirect to="/login"/>
                </Switch>
              </Suspense>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Base>
    )
  }
}

export default withRouter(Routes);
